import { useEffect, useState } from 'react'

import { useTheme } from '@mui/material'
import { LocalizationProvider, renderTimeViewClock } from '@mui/x-date-pickers'
import { MobileDateTimePicker as MuiDateTimePicker } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { PickerValue } from '@mui/x-date-pickers/internals'

type Props = {
  label: string
  value: PickerValue
  onChange: (value: PickerValue) => void
  required?: boolean
}

export const DateTimePicker = ({ label, value, required, onChange }: Props) => {
  const theme = useTheme()
  const renderedLabel = required ? `${label}*` : label
  const [internalValue, setInternalValue] = useState<PickerValue>(value)

  useEffect(() => {
    setInternalValue(value)
  }, [value])

  const handleChange = (value: PickerValue) => {
    setInternalValue(value)
  }

  const handleSave = () => {
    onChange(internalValue)
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <MuiDateTimePicker
        format="dd/MM/yyyy HH:mm"
        ampmInClock
        ampm={false}
        viewRenderers={{
          hours: renderTimeViewClock,
          minutes: renderTimeViewClock,
          seconds: renderTimeViewClock
        }}
        onChange={handleChange}
        onAccept={handleSave}
        label={renderedLabel}
        defaultValue={internalValue}
        value={internalValue}
        slotProps={{
          textField: {
            size: 'small',
            sx: {
              width: '100%',
              backgroundColor: theme.palette.mode === 'light' ? 'white' : '#383838',
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'white'
              }
            }
          }
        }}
        sx={{
          height: 37,
          width: '100%'
        }}
      />
    </LocalizationProvider>
  )
}
